import { KycCheckStatus, KycSessionStatus } from '@/common/types';
import type { KycSession } from '@/models/KycSession';
import { redirectToTimeoutWithSessionId } from './timeoutRedirector';
import type { RouteLocationRaw } from 'vue-router';

export function determineRouteToRedirect(kycSession: KycSession): RouteLocationRaw {
  let routeToRedirect;

  const sessionStatus = kycSession.status;
  const kycCheckStatus = kycSession.kycCheck?.status;

  if (!sessionStatus || sessionStatus === KycSessionStatus.CANCELLED) {
    routeToRedirect = redirectToTimeoutWithSessionId({ kycSession });
  } else if (sessionStatus !== KycSessionStatus.COMPLETED) {
    kycSession.steps.monitorRegionChange(kycSession);
    routeToRedirect = {
      name: kycSession.steps.screens[0],
    };
  } else {
    if (kycCheckStatus === KycCheckStatus.PASSED) {
      routeToRedirect = {
        name: 'Success',
      };
    } else if (kycCheckStatus === KycCheckStatus.FAILED) {
      routeToRedirect = {
        name: 'Failed',
      };
    } else if (
      kycCheckStatus === KycCheckStatus.PENDING ||
      kycCheckStatus === KycCheckStatus.CREATED
    ) {
      routeToRedirect = {
        name: 'Pending',
      };
    } else {
      throw new Error('Session status or/and kycCheck status is not valid');
    }
  }

  return routeToRedirect;
}
